import { Trans, useTranslation } from '@dagens/frontend-i18n';
import { FC } from 'react';
import styled from 'styled-components';

import Logger from '../../../services/Logger';
import DagensEmailLink from '../text-link/DagensEmailLink';
import Typography from '@carrot-deprecated/typography';
import DagensPhoneLink from '_common/components/text-link/DagensPhoneLink';

const ErrorMessageContainer = styled.div`
  max-width: 260px;
  margin: 60px auto;
  padding: 0 10px;
  text-align: center;
`;

type Props = {
  error?: Error;
};

const ErrorMessage: FC<Props> = ({ error }) => {
  if (error) {
    Logger.error(error);
  }

  const { t } = useTranslation();
  return (
    <ErrorMessageContainer>
      <Typography variant="paragraph" my="m">
        {t('common:errorOccured')}
      </Typography>
      <Typography variant="paragraph" color="secondary" my="m">
        {t('common:errorFeedback')}
      </Typography>
      <Typography variant="paragraph" color="secondary" my="m">
        <Trans
          t={t}
          i18nKey="common:errorFeedback2"
          components={{
            DagensPhoneLink: <DagensPhoneLink />,
            DagensEmailLink: <DagensEmailLink />
          }}
        />
      </Typography>
    </ErrorMessageContainer>
  );
};

export default ErrorMessage;
